import { createClient } from '@supabase/supabase-js';
import { reportEdgeFunctionError, setSentryUser } from './sentry';

const supabaseUrl = 'https://api.pickledepot.com.my';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im12dmhycGZhY2dtbmZpZ254dGtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUwNjIzNjAsImV4cCI6MjA2MDYzODM2MH0.mHAiPSOC3pS5vTBcQB-__TsziwT30gnyI9aVuxeSazw';

// const supabaseUrl = 'https://xxzrgvkakxgxpckrsztg.supabase.co';
// const supabaseAnonKey = 'sb_publishable_G7ZqGlXU0uVVC--Hw6nfnw_P3beKohF';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// --- Edge-function error reporting -------------------------------------------
// Wrap functions.invoke once so EVERY edge-function failure is captured with
// context and reported to Sentry, then passed through unchanged (zero call-site
// changes). supabase-js returns errors in `{ data, error }` rather than throwing:
//   - FunctionsFetchError  → "Failed to send a request to the Edge Function"
//                            (no readable CORS response / the worker crashed)
//   - FunctionsHttpError   → a non-2xx response that DID return a body
// We report both, and also re-throw genuine exceptions, so existing `if (error)`
// handling everywhere is untouched.
const _invoke = supabase.functions.invoke.bind(supabase.functions);
supabase.functions.invoke = async (functionName, options = {}) => {
  try {
    const result = await _invoke(functionName, options);
    if (result?.error) reportEdgeFunctionError(functionName, result.error, options);
    return result;
  } catch (thrown) {
    reportEdgeFunctionError(functionName, thrown, options);
    throw thrown;
  }
};

// Tie every reported error to the signed-in user (id + email) for easy triage.
supabase.auth.getSession().then(({ data }) => setSentryUser(data?.session?.user ?? null));
supabase.auth.onAuthStateChange((_event, session) => setSentryUser(session?.user ?? null));